<template>
  <div>
    <vs-alert
      style="margin-bottom: 20px"
      :active.sync="alert.active1"
      closable
      close-icon="close"
      :title="alert.title"
      :color="alert.color"
      >{{ alert.message }}</vs-alert
    >
    <div id="dashboard-loading" class="vs-con-loading__container">
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="3"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-card class="m-2">
            <template v-slot:header>
              <div class="heading">Total Admins</div>
            </template>
            <h1 class="count">{{ admins }}</h1>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="3"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-card class="m-2">
            <template v-slot:header>
              <div class="heading">Total Clinics</div>
            </template>
            <h1 class="count">{{ clinics }}</h1>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="3"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-card class="m-2">
            <template v-slot:header>
              <div class="heading">Total Organizations</div>
            </template>
            <h1 class="count">{{ organizations }}</h1>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="3"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-card class="m-2">
            <template v-slot:header>
              <div class="heading">Total Doctors</div>
            </template>
            <h1 class="count">{{ doctors }}</h1>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="3"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-card class="m-2">
            <template v-slot:header>
              <div class="heading">Total Nurses</div>
            </template>
            <h1 class="count">{{ nurses }}</h1>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="3"
          vs-sm="3"
          vs-xs="12"
        >
          <vs-card class="m-2">
            <template v-slot:header>
              <div class="heading">Total Patients</div>
            </template>
            <h1 class="count">{{ patients }}</h1>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      admins: 0,
      clinics: 0,
      doctors: 0,
      nurses: 0,
      patients: 0,
      organizations: 0,
      alert: {
        active1: false,
        color: 'success',
        title: 'connected',
      },
      activeClinicId: '',
    };
  },
  methods: {
    ...mapActions('admin', ['getSuperAdminDashboardData']),
    getData() {
      this.$vs.loading({
        container: '#dashboard-loading',
        scale: 0.6,
      });
      this.getSuperAdminDashboardData().then((res) => {
        this.clinics = res.data.data.clinics;
        this.doctors = res.data.data.doctors;
        this.nurses = res.data.data.nurses;
        this.patients = res.data.data.patients;
        this.admins = res.data.data.admins;
        this.organizations = res.data.data.organizations;
        this.$vs.loading.close('#dashboard-loading > .con-vs-loading');
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
.count {
  text-align: center;
  font-size: x-large;
  font-weight: bold;
}
.heading {
  font-size: large;
  font-weight: 600;
  color: black;
}
</style>
